/**
 * Portal content shell — NavBar, landing hero, permits, footer, etc.
 *
 * Desktop column: scales with viewport then caps — see `maxWidth` below.
 *
 * Horizontal shell padding uses **`clamp`** on `lg`+ so it does **not** keep scaling up with
 * ultrawide widths (fixed `theme.spacing` felt like ever-growing gutters next to `mx: auto`).
 */
export const portalContentMaxWidthSx = {
    width: '100%',
    maxWidth: {
        xs: '100%',
        sm: '100%',
        md: '100%',
        /** Wider `xl` cap so 4K / large gov displays use horizontal space (was 1680 → large side gutters). */
        lg: 'min(100%, clamp(1100px, 90vw, 1800px))',
        xl: 'min(100%, clamp(1160px, 92vw, 2040px))',
    },
    mx: 'auto',
    boxSizing: 'border-box',
};
/**
 * Shell gutter — capped so wide monitors don’t accumulate huge left/right inset (padding +
 * centered column margins).
 */
export const portalPageHorizontalPaddingSx = {
    px: {
        xs: 2,
        sm: 3,
        md: 4,
        /** Gutter grows modestly on large monitors without leaving huge dead margins on ultrawide. */
        lg: 'clamp(18px, 2.4vw, 40px)',
        xl: 'clamp(18px, 2.4vw, 40px)',
    },
    boxSizing: 'border-box',
};
/** Nav `Toolbar` min-height — `svh` tracks display scaling better than fixed px. */
export const portalNavToolbarMinHeight = {
    xs: 'clamp(40px, 4.2svh, 48px)',
    md: '48px',
};
/** Seal / wordmark lockup in NavBar — scales with viewport short side. */
export const portalNavSealHeight = {
    xs: 'clamp(30px, 3.8svh, 36px)',
    md: 'clamp(32px, 4.2svh, 40px)',
};
/** Spacer under fixed AppBar — must match `portalNavToolbarMinHeight` + AppBar `pt`. */
export function portalNavLayoutOffset(theme) {
    return {
        xs: `calc(${theme.spacing(0.5)} + ${portalNavToolbarMinHeight.xs} + env(safe-area-inset-top, 0px))`,
        md: `calc(${theme.spacing(0.5)} + ${portalNavToolbarMinHeight.md} + env(safe-area-inset-top, 0px))`,
    };
}
